import { stats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center py-6 px-4 bg-background-50 rounded-lg">
              <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-primary-500`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading text-foreground-800 mb-1">{stat.value}</div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}